<!--
    *ngIf="true" hack is required here for router-outlet to work
    correctly. Otherwise, it won't register the changes on the
    layout and won't update the view.
 -->
<router-outlet *ngIf="true">

    <!-- <button color="accent" class="btn fourth " (click)="tutorial()"
        style="position: fixed ; bottom:0 ;left:0 ;z-index: 9999;">Tutorial</button> -->
</router-outlet>